import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {XmedicalUiModule} from '@xmedical/ui';

export interface AppointmentPatientMetaDataFormDialogData {
  name: string;
  cell: string;
  email: string;
}

@Component({
  selector: 'app-appointment-patient-meta-data-form',
  templateUrl: './appointment-patient-meta-data-form.component.html',
  styleUrl: './appointment-patient-meta-data-form.component.scss',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    XmedicalUiModule,
  ],
  providers: [DatePipe]
})
export class AppointmentPatientMetaDataFormComponent implements OnInit {

  form: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<AppointmentPatientMetaDataFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: AppointmentPatientMetaDataFormDialogData,
    public datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [''],
      cell: [''],
      email: [''],
    });
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }
}
